import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

/* =========================
   NewsCard Component
========================= */
function NewsCard({ article }) {
  const { title, description, image, source, link } = article;

  return (
    <div
      className="card shadow-sm border-0 h-100"
      style={{
        cursor: "pointer",
        transition: "all 0.3s ease",
        borderRadius: "15px",
        overflow: "hidden",
      }}
    >
      {image && (
        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            height: "180px",
            objectFit: "cover",
          }}
        />
      )}

      <div className="content p-3">
        <span
          style={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#0066cc",
          }}
        >
          {"Feb 2026"}
        </span>

        <div className="fw-bold ">{title}</div>

        <div
          style={{
            fontSize: "14px",
            color: "#666",
            marginTop: "6px",
          }}
        >
          {description || ""}
        </div>

        <div
          style={{
            fontSize: "13px",
            marginTop: "10px",
            color: "#1e3c72",
            fontWeight: 500,
          }}
        >
          Read More →
        </div>
      </div>
    </div>
  );
}

/* =========================
   Immigration Hub
========================= */

const countries = [
  {
    name: "2026 U.S. Immigration Policies affecting Indian/Bharat Nationals",
    path: "/news/immigration-2026/us",
    flag:
      "https://c.ndtvimg.com/2025-11/gg39q6h8_us-immigration-fee_625x300_21_November_25.jpeg?downsize=545:307",
  },
  {
    name: "UK Immigration Reforms 2026 for Indian/Bharat Nationals",
    path: "/news/uk-immigration-2026",
    flag:
      "https://cdn.prod.website-files.com/63e4ca13cde96a2d7995426a/6830453572ce41fcf087bf20_4.png",
  },
  {
    name: "Canada’s 2026 Immigration Reset Hits Bharat/Indians",
    path: "/news/canada-immigration-reset-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTub6xV8tn0OAdlmFNTT59LWlNow3OMsdGfCQ&s",
  },
  {
    name: "Australia Tightens Visa Rules in 2026",
    path: "/news/australia-visa-reforms-2026",
    flag:
      "https://jamesonlaw.com.au/wp-content/uploads/emplibot/Are-Australia_s-Immigration-Laws-Strict__1749870647.webp",
  },
  {
    name: "Germany’s 2026 Immigration Push",
    path: "/news/germany-immigration-push-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAd5p5pbyoXjXmPIMcHt9n-aaFWsEMuHa1DQ&s",
  },
  {
    name: "Stricter Enforcement, Selective Easing",
    path: "/news/middle-east-immigration-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsNi2gxguTJK0iop0-Cx9Ti0KvAlP_NTyKVQ&s",
  },
  {
    name: "Higher Costs, Stricter Rules, Selective Pathways",
    path: "/news/new-zealand-immigration-reset-2026",
    flag:
      "https://media.licdn.com/dms/image/v2/C4E12AQHISBqlsC3Dcw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1542681225790?e=2147483647&v=beta&t=wm_Gyay4KA2LM1LyOYB-felzKrCGZIFv50Ir8gXbAIs",
  },
  {
    name: "No-Boarding Directive Brings Stricter Pre-Departure Checks",
    path: "/news/singapore-immigration-2026",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvy2Tg_e5g5FIRdW4_yF7OwCdSxbRwo47VnQ&s",
  },
];

const ImmigrationHub2026 = () => {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: "#f4f8fb", minHeight: "100vh" }}>
      {/* HERO */}
      <div
        style={{
          background: "linear-gradient(135deg, #1e3c72, #2a5298)",
          color: "white",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <Container>
          <h1 className="fw-bold">Global Immigration 2026</h1>
          <p className="lead mt-3">
            Explore major immigration policy changes impacting Indian/Bharat
            nationals worldwide.
          </p>
        </Container>
      </div>

      {/* COUNTRY CARDS */}
      <Container fluid className="py-5">
        <Row>
          {countries.map((country, index) => {
            const articleData = {
              title: country.name,
              description: "Immigration Updates 2026",
              image: country.flag,
              source: "Global Immigration 2026",
              link: country.path,
            };

            return (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <div
                  onClick={() => navigate(country.path)}
                  onMouseEnter={(e) => {
                    e.currentTarget.firstChild.style.transform =
                      "translateY(-5px)";
                    e.currentTarget.firstChild.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.firstChild.style.transform =
                      "translateY(0px)";
                    e.currentTarget.firstChild.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.08)";
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <NewsCard article={articleData} />
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default ImmigrationHub2026;
